import { useOidc } from '@axa-fr/react-oidc';
import { useLeaveWhenLicensed } from '@metaforcelabs/docgen-identity-web/src/react/index.js';
import { setAuthHeader } from '../../api/api';
import { hasInteractAdminLicense } from '../../utils/license';

export const MissingLicense = () => {
  const { renewTokens } = useOidc();

  useLeaveWhenLicensed({
    renewTokens,
    setAuthHeader,
    isLicensed: hasInteractAdminLicense,
    // Full navigation, so nothing built for the unlicensed company is reused.
    onLicensed: () => window.location.replace('/'),
    onRenewalError: (error) => console.log('MissingLicense - renewal error:', error),
    onCheckError: (error) => console.log('MissingLicense - licence check error:', error),
  });

  return (
    <>
      User is missing license to access this feature.
    </>
  )
}
